module.exports = __webpack_public_path__ + "img/hurricane-03.882b0c78.svg";